/* eslint-disable import/prefer-default-export */

export const USER_TYPE = {
    BORROWER: 1,
    LENDER_PERSONAL: 2,
    LENDER_INSTITUTIONAL: 3,
    BORROWER_INSTITUTIONAL: 4,
};
